/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptions, FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverridesOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAvailabilityOverrides.js.map